// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cX","homeContent__bottom":"c-i_cY","homeContent__cardHolder":"c-i_cZ","homeContent__seoTextHolder":"c-i_ea"};